const Images = {
    formBird: require('../assets/formBird.png'),
    logo: require('../assets/logo.png'),
    subBird: require('../assets/subBird.png'),
}

export default Images;